import { render, staticRenderFns } from "./bdxq.vue?vue&type=template&id=56ba29b4&scoped=true&"
import script from "./bdxq.vue?vue&type=script&lang=js&"
export * from "./bdxq.vue?vue&type=script&lang=js&"
import style0 from "./bdxq.vue?vue&type=style&index=0&id=56ba29b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ba29b4",
  null
  
)

export default component.exports